import { render, staticRenderFns } from "./WinPrizeTable.vue?vue&type=template&id=fe1c41c4&scoped=true&"
import script from "./WinPrizeTable.vue?vue&type=script&lang=js&"
export * from "./WinPrizeTable.vue?vue&type=script&lang=js&"
import style0 from "./WinPrizeTable.vue?vue&type=style&index=0&id=fe1c41c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1c41c4",
  null
  
)

export default component.exports